import React from "react";
import { NavLink, Link } from "react-router-dom";
import { AiOutlineWhatsApp } from "react-icons/ai";
import {
  FaFacebookF,
  FaInstagram,
  FaTiktok,
  FaYoutube,
  FaTelegramPlane,
} from "react-icons/fa";
import { FiGlobe, FiAlertTriangle, FiMapPin, FiHeadphones } from "react-icons/fi";
import { useGetAllCategoryListQuery } from "../../../utils/api/category/category.api";
import VersionChecker from "../../../versionChecker/VersionChecker";
import { WHATSAPP_RDV_URL } from "../../../utils/whatsapp";

// TODO: remplacer par des données dynamiques (API / config) si besoin
const CABINETS = [
  {
    id: 1,
    ville: "Nouakchott, Mauritanie",
    adresse: "Sixième Robinet 5",
    telephones: ["+222 41 49 58 12", "+222 32 75 73 60"],
  },
  {
    id: 2,
    ville: "Pikine, Sénégal",
    adresse: null,
    telephones: ["+221 78 270 73 50"],
  },
];

const ACCOMPAGNEMENTS_FOOTER = [
  { key: "phyto", label: "Phytothérapie" },
  { key: "medecine", label: "Médecine prophétique" },
  { key: "hijama", label: "Hijama" },
  { key: "roqya", label: "Roqya" },
];
const FoutaFooter = () => {
  const { data } = useGetAllCategoryListQuery();
  const date = new Date();

  return (
    <footer className="footer-component">
      <div className="container pt-5 pb-3">
        <div className="row footer-top mb-4">
          {/* Colonne : Marque + description + réseaux sociaux */}
          <div className="col-lg-3 col-md-6 col-12 mb-4">
            <NavLink to="/" className="footer-brand-home-link" aria-label="Retour à l'accueil">
              <h3 className="footer-brand-title">Fouta Bio</h3>
            </NavLink>
            <p className="footer-brand-desc">
              Phytothérapie, médecine prophétique, Hijama, Roqya et produits
              naturels sélectionnés avec attention.
            </p>
            <div className="footer-social-icons">
              <a
                href="https://wa.me/message/PGFSB43ZO3S5K1"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="WhatsApp"
              >
                <AiOutlineWhatsApp size={18} />
              </a>

              <a
                href="https://youtube.com/channel/UC3jiei2AdEb6k2RjQDa2VXA"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="YouTube"
              >
                <FaYoutube size={16} />
              </a>

              <a
                href="https://www.instagram.com/invites/contact/?i=1sbjiij4t3srb&utm_content=qwqnqq"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="Instagram"
              >
                <FaInstagram size={16} />
              </a>

              <a
                href="https://www.tiktok.com/@maitre_ventouse?_r=1&_t=ZS-99G3yLbWS5w"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="TikTok"
              >
                <FaTiktok size={16} />
              </a>

              <a
                href="https://www.facebook.com/FoutaBio/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="Facebook"
              >
                <FaFacebookF size={16} />
              </a>

              <a
                href="https://t.me/foutabio"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-icon"
                aria-label="Telegram"
              >
                <FaTelegramPlane size={16} />
              </a>
            </div>
          </div>

          {/* Colonne : Navigation */}
          <div className="col-lg-2 col-md-6 col-12 mb-4">
            <p className="footer-col-title">Navigation</p>
            <ul className="footer-list">
              <li>
                <NavLink className="link-footer" to="/about">
                  À propos
                </NavLink>
              </li>
              <li>
                <NavLink className="link-footer" to="/accompagnements">
                  Accompagnements
                </NavLink>
              </li>
              <li>
                <NavLink className="link-footer" to="/produitspage">
                  Produits
                </NavLink>
              </li>
              <li>
                <NavLink className="link-footer" to="/conseils">
                  Conseils
                </NavLink>
              </li>
              <li>
                <NavLink className="link-footer" to="/faq">
                  FAQ
                </NavLink>
              </li>
              <li>
                <NavLink className="link-footer" to="/contact">
                  Contact
                </NavLink>
              </li>
              <li>
                <a
                  className="link-footer"
                  href={WHATSAPP_RDV_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Prendre rendez-vous
                </a>
              </li>
            </ul>
          </div>

          {/* Colonne : Accompagnements (catégories) */}
         {/* Colonne : Accompagnements */}
<div className="col-lg-2 col-md-6 col-12 mb-4">
  <p className="footer-col-title">Accompagnements</p>
  <ul className="footer-list">
    {ACCOMPAGNEMENTS_FOOTER.map((item) => (
      <li key={item.key}>
        <Link className="link-footer" to={`/accompagnements#${item.key}`}>
          {item.label}
        </Link>
      </li>
    ))}
  </ul>
</div>

          {/* Colonne : Nos cabinets */}
          <div className="col-lg-5 col-12 mb-4">
            <p className="footer-col-title">Nos cabinets</p>
            <div className="footer-cabinets">
              {CABINETS.map((cabinet) => (
                <div className="cabinet-card" key={cabinet.id}>
                  <div className="cabinet-header">
                    <FiMapPin className="cabinet-icon-pin" />
                    <h4 className="cabinet-title">{cabinet.ville}</h4>
                  </div>

                  <div className="cabinet-body">
                    {cabinet.adresse && (
                      <div className="cabinet-line">
                        <FiHeadphones className="cabinet-icon-line" />
                        <span>{cabinet.adresse}</span>
                      </div>
                    )}
                    {cabinet.telephones.map((tel) => (
                      <a
                        key={tel}
                        href={`https://wa.me/${tel.replace(/\D/g, "")}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cabinet-line cabinet-phone"
                      >
                        <AiOutlineWhatsApp className="cabinet-icon-line whatsapp" />
                        <span>{tel}</span>
                      </a>
                    ))}
                  </div>

                  <div className="cabinet-separator" />

                  <a
                    href={WHATSAPP_RDV_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cabinet-cta-btn"
                  >
                    Prendre rendez-vous
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Site web centré */}
        <div className="footer-website text-center mb-4">
          <a
            href="https://www.foutabio.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-website-link"
          >
            <FiGlobe className="footer-website-icon" />
            <span>www.foutabio.com</span>
          </a>
        </div>

        {/* Bas de page */}
        <div className="footer-separator" />
        <div className="footer-bottom">
          <p className="footer-disclaimer">
            <FiAlertTriangle className="footer-disclaimer-icon" />
            Les informations présentées sur ce site sont générales et ne
            remplacent pas une consultation médicale personnalisée.
          </p>

          <div className="footer-bottom-links">
            <NavLink to="/">Mentions légales</NavLink>
            <NavLink to="/">
              Politique de confidentialité
            </NavLink>
            <NavLink to="/cookies">Cookies</NavLink>
          </div>

          <p className="footer-copyright">© {date.getFullYear()} Fouta Bio</p>
        </div>

        <div className="version-view-container text-end text-white fw-bold">
          {"v" + VersionChecker()}
        </div>
      </div>
    </footer>
  );
};

export default FoutaFooter;